import { toast } from 'sonner'
import { handleApiError } from './api-client'

export function notifyApiError(error: unknown, context?: string) {
  const message = handleApiError(error)
  toast.error(context ? `${context}: ${message}` : message)
}
